import { ItemStatus } from "@/services/collection/item/collectionItemTypes";
import { revertMap } from "@/utilities/map";

export enum ItemStatusUrlString {
  InMyCollection = "collection",
  NotInCollection = "notInCollection",
  OnMarketplace = "marketplace",
  Deleted = "deleted",
}

export const ItemStatusToUrlString: Record<ItemStatus, ItemStatusUrlString> = {
  [ItemStatus.InMyCollection]: ItemStatusUrlString.InMyCollection,
  [ItemStatus.OnMarketplace]: ItemStatusUrlString.OnMarketplace,
  [ItemStatus.Deleted]: ItemStatusUrlString.Deleted,
  [ItemStatus.NotInCollection]: ItemStatusUrlString.NotInCollection,
};

export const UrlStringToItemStatus = revertMap(ItemStatusToUrlString);
